/// <amd-module name="Test/TestCaseResults/Redux/TestCaseResultsActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import * as Contracts from "TestPlanCommon/Contracts/TestPlan";

import { IRunDetailsItem } from "./TestCaseResultsContracts";

export const TestCaseResultsActions = {
    /**
     * loadInitialResultsData: fetch results data from data-provider
     */
    loadInitialResultsData: () => createAction(TestCaseResultsActionsTypes.loadInitialResultsData),

    /**
     * loadInitialTestDataSucceeded: Dispatched after initial data loading completes.
     */
    loadInitialResultsDataSucceeded: (initialData: Contracts.TestCaseResultsData) =>
        createAction(TestCaseResultsActionsTypes.loadInitialResultsDataSucceeded, initialData),

    /**
     * This action is used to open the test result for test point
     */
    openRunsHub: (pointId: number, runId: number, resultId: number) =>
        createAction(TestCaseResultsActionsTypes.openRunsHub, { pointId, runId, resultId }),

    /**
     * Action to update filteredResults in store, the selector will use this to return test cases to render
     */
    updateFilteredResults: (filteredResults: IRunDetailsItem[] | undefined) =>
        createAction(TestCaseResultsActionsTypes.updateFilteredResults, { filteredResults }),

    /**
     * This action is used during paging where as new data comes in, we need to re-evaluate the filtered items
     */
    triggerEvaluateFilter: () => createAction(TestCaseResultsActionsTypes.triggerEvaluateFilter),

    /**
     * This action is dispatched to persist execution history table column widths in state
     */
    changeColumnWidths: (columnId: string, width: number) => createAction(TestCaseResultsActionsTypes.changeColumnWidths, { columnId, width })
};

export const enum TestCaseResultsActionsTypes {
    loadInitialResultsData = "TestCaseResults/loadInitialResultsData",
    loadInitialResultsDataSucceeded = "TestCaseResults/loadInitialResultsDataSucceeded",
    openRunsHub = "TestCaseResults/openRunsHub",
    updateFilteredResults = "TestCaseResults/updateFilteredResults",
    triggerEvaluateFilter = "TestCaseResults/triggerEvaluateFilter",
    changeColumnWidths = "TestCaseResults/changeColumnWidths"
}

export type TestCaseResultsActions = ActionsUnion<typeof TestCaseResultsActions>;
